import React, { useState, useContext, useEffect, useMemo } from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'

import Cookies from 'js-cookie'
import cn from 'classnames'
import Octicon, { ChevronDown, SignOut, Comment, CreditCard, Search, DiffAdded, DiffRemoved } from '@primer/octicons-react'
import Loader from 'react-loader-spinner'
import { currencyFormatter } from '~/utils/formatters'

import { ActionButtons, Container, SessionContext } from '~/components'
import { SubMenu, Ul, FixedDiv } from './styles'
import { DEALER_TYPES, LINKS } from '~/constants'

import { ButtonModal, PickupForm } from '@viadelivery/design-system'
import { useAtom } from 'jotai'
import { modalPickupAtom, catchFocusAtom } from '~/states'
import { useQuery } from 'react-query'
import { getData } from '~/utils/api'

import CarrierFilter from '~/components/OrdersPage/CarrierFilter'
import DatePicker from '~/components/OrdersPage/DatePicker'
import Options from '~/components/OrdersPage/Options'
import CollapseableList from '~/components/Dealers/CollapsableList'
import { saveUserSettings } from '~/utils/UserSettings'

import styles from '~/styles/menu.module.css'

let dropdownCount = 0
// let startDateRange = {}
let searchTO

const Menu = ({ 
    t, locale, action, links, showPickup = false, 
    clickLabel, title, callback, removeChartDateAndStatus,
    setCurrentPage,
    timezoneCode, setTimezoneCode,
    timezoneName, setTimezoneName,
    sortingPickerType, setSortingPickerType,
    appState, setAppState,
    onAction, route
  }) => {
  const router = useRouter()
  const { dealersObject, currentDealer, userSettings } = useContext(SessionContext)
  const [ collapsedDealers, setCollapsedDealers ] = useState({})
  const [ collapsableDealers, setCollapsableDealers ] = useState({})
  const [ openedDealers, setOpenedDealers ] = useState({})
  const [ forcedToShow, setForcedToShow ] = useState({})
  const [ hiddenDealers, setHiddenDealers ] = useState({})
  const [showSubMenu, setShowSubMenu] = useState(false)
  const [loading, setLoading] = useState(false)
  const { name, type, uuid, dealer_country } = currentDealer
  const [isOpen, toggleModal] = useAtom(modalPickupAtom)
  const [, setCatchFocus] = useAtom(catchFocusAtom)
  const [filteredDealers, setFilteredDealers] = useState([])
  const [searchDealer, setSearchDealer] = useState('')
  const [datesFilter, setDatesFilter] = useState(userSettings)
  const [ search, setSearch ] = useState('')

  if (!(clickLabel + '').startsWith('dealersMenu')) {
    dropdownCount = 0
  }
  const handleClick = () =>  {
    dropdownCount++
    onAction?.send({
      action: 'Menu click',
      actionData: {
        file: 'components/Menu/index.tsx',
        clickedTo: 'Menu of dealers',
      },
    })
    setShowSubMenu(!showSubMenu)
  }

  const onPickupClose = () => {
    setCatchFocus(true)
  }

  const toggleModalPickup = () => {
    if (typeof BXLiveChat !== 'undefined') {
      BXLiveChat.close()
    }
    toggleModal(!isOpen)
    setCatchFocus(false)
    onAction?.send({
      action: 'Request a Pickup',
      actionData: {
        file: 'components/Menu/index.tsx',
        isOpen,
      },
    })
  }

  const handleDateSelect = (dates: DATES_RANGE) => {
    // startDateRange = dates
    setDatesFilter(dates)
    callback(dates, Date.now())
  }

  const handleProfileChange = (dealerId: number) => {
    Cookies.remove('currentDealer')
    Cookies.set('currentDealer', dealerId)
    setShowSubMenu(!showSubMenu)
    setLoading(true)
    onAction?.send({
      action: 'Dealer switch',
      actionData: {
        file: 'components/Menu/index.tsx',
        dealerId,
      },
    })
    router.reload()
  }

  const handleLanguageSwitch = () => {
    Cookies.set('next-i18next', locale === 'ru' ? 'en' : 'ru')
    setShowSubMenu(!showSubMenu)
    setLoading(true)
    onAction?.send({
      action: 'Menu click',
      actionData: {
        file: 'components/Menu/index.tsx',
        clickedTo: 'Language switch',
        lang: (locale === 'ru' ? 'en' : 'ru'),
      },
    })
    router.reload()
  }

  const handleLogout = () => {
    Cookies.remove('session')
    Cookies.remove('currentDealer')
    Cookies.remove('access_token')
    Cookies.remove('access_realm')
    setShowSubMenu(!showSubMenu)
    setLoading(true)
    onAction?.send({
      action: 'Menu click',
      actionData: {
        file: 'components/Menu/index.tsx',
        clickedTo: 'Logout',
      },
    })
    router.push('/login')
  }

  const onSuccessPickup = () => {
    toggleModalPickup(false)
    onAction?.send({
      action: 'Request a Pickup',
      actionData: {
        file: 'components/Menu/index.tsx',
        success: true,
      },
    })
  }

  let getBalance = () => {
   return useQuery([], async () => {
      // let result = Menu.balance
      // if (!Menu.balance?.date || (Date.now() - Menu.balance.date) > 1000 * 60 * 3) {
      //  result = await getData("/api/v1/balance", {
      //    currentDealer: currentDealer.id,
      //    access_token: Cookies.get('access_token'),
      //    access_realm: Cookies.get('access_realm'),
      //  })
      //    if (result?.error === 'Access forbidden') {
      //      router.reload()
      //    } else {
      //     Menu.balance = result
      //     Menu.balance.date = Date.now()
      //    }
      // }
      // return result
     return {}
    })
  }

  const { data: balanceData, isLoading: balanceLoading } = type !== DEALER_TYPES.PPN ? getBalance() : {}

  useEffect(() => {
    // Set display name in the box to currentDealer from the session on mount
    Cookies.set('currentDealer', currentDealer.id)
  }, [])

  const phoneNumber = useMemo(() => t('common:General Phone Number'), [locale])

  const onClick = (originHeaderLink, currentPage, href) => {
    onAction?.send({
      action: 'Menu click',
      actionData: {
        file: 'components/Menu/index.tsx',
        location: window.location.href,
        href,
      },
    })
    if (typeof removeChartDateAndStatus === 'function') {
      removeChartDateAndStatus()
    }
    saveUserSettings(JSON.stringify({ id: 'originHeaderLink', value: originHeaderLink }))
    Cookies.set('href', href)
    if (typeof setCurrentPage === 'function') {
      setCurrentPage(currentPage)
    }
  }
  
  const isCommonDealer = ['35877652-9900-4767-b64b-8214dac5e848', 'syntheticIdForManagersCommonUsDealer', 'syntheticIdForManagersCommonGbDealer'].includes(uuid)
  const enCountries = ['US', 'GB', 'UK', 'CA']
	const headerLinks = [] // Dashboard, Orders, Settings
	LINKS[type]?.forEach(link => {

    const isCurrentPage = !!router.pathname.match(new RegExp(`\\b${link.page}$`))
		const areSettingsForViaDeliveryCountryHide = (link.page === 'settings' && isCommonDealer)
		const areClientOptionsForViaDeliveryCountryHide = (link.page === 'client-options' && isCommonDealer)
		const areDocumentsForUs = (link.page === 'documents' && enCountries.includes(currentDealer.dealer_country))
    const areDocumentsForSynthetic = (link.page === 'documents' && isCommonDealer)
    let isRedirectsHidden = (link.page === 'redirects' && !enCountries.includes(currentDealer.dealer_country))
    if (currentDealer.enable_bopar === 'N' && link.page === 'redirects') {
      isRedirectsHidden = true
    }
		if (!areSettingsForViaDeliveryCountryHide && !areClientOptionsForViaDeliveryCountryHide && !areDocumentsForUs && !areDocumentsForSynthetic && !isRedirectsHidden) {
      const href = `/${type.toLowerCase()}/${link.page}`
			headerLinks.push((
				<Link 
          href={href}
          key={link.page}
        >
					<a
						tabIndex={0}
						className={cn(
							'py-3 inline-block font-semibold text-gray-700 hover:bg-brand-100 rounded mr-4 capitalize',
							{
								'text-brand-500 active': isCurrentPage,
							},
						)}
            onClick={onClick.bind(this, (isCurrentPage ? null : router.pathname), link.page, href)}
					>
						{t(`common:${link.page}`)}
					</a>
				</Link>
			))
		}
	})

  const onSearch = (event) => {
    // setForcedToShow({})
    setSearchDealer(event.target?.value)
    setSearch(event.target?.value)
    if (searchTO) {
      clearTimeout(searchTO)
    }
    searchTO = setTimeout(() => {
      onAction?.send({
        action: 'Dealer search',
        actionData: {
          file: 'components/Menu/index.tsx',
          search: event.target?.value,
        },
      })
    }, 1000)
  }

  return (
    <Container className={styles.main}>
      <div className="flex items-center justify-start">
        <div className="overflow-hidden mr-8">
          <img src="/assets/viadelivery-logo.png" width={160} height={54} />
        </div>
        <div className="mr-4">
			   {headerLinks}
        </div>
        {type === DEALER_TYPES.PPN && (
          <div className="py-2 px-4 rounded bg-gray-200 shadow-inner text-sm text-gray-800 relative">
            <div
              style={{ fontSize: '12px' }}
              className="text-brand-500 flex items-center mb-1"
            >
              <Octicon icon={Comment} className=" mr-2" size="small" />
              {t('common:Support')}
            </div>
            <div className="flex items-center">
              <div className="mr-3">
                <a href={`tel: ${phoneNumber}`}>{phoneNumber}</a>
              </div>
              <a href="mailto:support@via.delivery" className="inline-block">
                support@via.delivery
              </a>
            </div>
          </div>
        )}
      </div>

      {title === 'dashboard' && ( 
        <div 
         className={styles.someSettings}
        >
          <div className={styles.datePicker}>
            <DatePicker
              {...datesFilter}
              onSelect={handleDateSelect}
              show="true"
              timezoneCode={timezoneCode}
              setTimezoneCode={setTimezoneCode}
              timezoneName={timezoneName}
              setTimezoneName={setTimezoneName}
              onAction={onAction}
              route={route}
              locale={locale}
              t={t}
            />
          </div>
          <CarrierFilter
            show={enCountries.includes(currentDealer.dealer_country)}
            appState={appState}
            setAppState={setAppState}
            t={t}
          />
          <div className={styles.options}>
            <Options
              timezoneCode={timezoneCode}
              setTimezoneCode={setTimezoneCode}
              timezoneName={timezoneName}
              setTimezoneName={setTimezoneName}
              sortingPickerType={sortingPickerType}
              setSortingPickerType={setSortingPickerType}
              clickLabel={clickLabel}
              onAction={onAction}
              t={t}
            />
          </div>
        </div>
      )}

      <div className="flex align-center">
        {!isCommonDealer && ( 
          <ActionButtons 
            hint="New Order and Print Labels"
            action={action}
            links={links}
            isAbleToCreateOrder={currentDealer.isAbleToCreateOrder}
            onAction={onAction}
            currentDealer={currentDealer}
          />
        )}
        {!isCommonDealer && showPickup && (
          <ButtonModal
            className="shadow-md ml-3 p-2 hover:bg-brand-600"
            title={t('common:Order a Pickup')}
            isModalOpen={isOpen}
            onClose={onPickupClose}
            toggleModal={toggleModalPickup}
          >
            <PickupForm
              locale={locale}
              dealerId={uuid}
              dealerCountry={currentDealer.dealer_country}
              onSuccess={onSuccessPickup}
            />
          </ButtonModal>
        )}

        <button
          className="rounded py-2 pl-4 pr-1 flex justify-center items-center border border-gray-400 flex justify-around items-center ml-8"
          onClick={handleClick}
          clicklabel="dealersMenu"
          data-testid="profile-menu"
        >
          <span className={"mr-2 text-sm" + (isCommonDealer ? ' px-2 font-semibold' : '')}>
            {loading ? (
              <Loader type="TailSpin" color="#2D3748" height={20} width={20} />
            ) : (
              <>
                {name}
                {false && !isCommonDealer && type !== DEALER_TYPES.PPN && !balanceLoading &&
                  <span className={cn(
                    'bg-gray-200 p-1 px-2 rounded ml-2',
                    {'bg-red-200': balanceData?.dealerBlocked}
                  )}>
                    <Octicon icon={CreditCard} className="mr-1"/>
                    {currencyFormatter({value: balanceData?.value, currency: balanceData?.dealerCurrency})}
                  </span>
                }
              </>
            )}
          </span>
          <Octicon icon={ChevronDown} className="mr-1" />
        </button>
      </div>
      {((clickLabel + '').startsWith('dealersMenu') && dropdownCount%2 !== 0) && (
        <SubMenu
          className={"absolute rounded bg-white shadow-md text-sm" + (loading ? " hidden" : "")}
          data-testid="profile-submenu"
        >
          {Object.keys(dealersObject || {}).length > 1 && (
            <div className="flex align-start">
              <Ul>
                <li key="search">
                  <div className="m-3 relative">
                    <input
                      placeholder="Type to search"
                      type="search"
                      className={"relative pl-3 py-2 pr-10 border border-gray-400 text-gray-800 w-full bg-transparent rounded " + styles.dealerMenuSearch}
                      value={searchDealer}
                      clicklabel="dealersMenuSearch"
                      onChange={onSearch}
                      autoComplete="off"
                      autoCorrect="off"
                      spellCheck="false"
                    />
                    <Octicon icon={Search} className="absolute top-3 right-3" />
                  </div>
                </li>
                <CollapseableList
                  dealersObject={dealersObject}
                  currentDealer={currentDealer}
                  search={search}
                  onDealerChange={handleProfileChange}
                  clickLabel="dealersMenuCollapseableList"
                />
              </Ul>
            </div>
          )}
    		  <FixedDiv>
    			{enCountries.includes(dealer_country) ? null : (
    				<button
    				  onClick={handleLanguageSwitch}
    				  data-testid="logout-button"
    				  className={"w-full mt-4" + (dealer_country === 'en' ? ' hidden' : '')}
    				>
    				  <div className="block px-6 py-3 hover:bg-brand-100 flex justify-center items-center">
    					<img
    					  src={`/assets/flag-${locale === 'ru' ? 'en' : 'ru'}.svg`}
    					  alt="country flag"
    					  className="w-4"
    					/>
    					<span className="ml-4">
    					  {locale === 'ru' ? 'English' : 'Русский'}
    					</span>
    				  </div>
    				</button>
    			)}
    			<button
    			  onClick={handleLogout}
    			  data-testid="logout-button"
    			  className={"w-full" + ' ' + styles.logout}
    			>
    			  <div className="block px-6 py-3 hover:bg-brand-100 ">
    				<Octicon icon={SignOut} />
    				<span className="ml-4">{t('common:Log out')}</span>
    			  </div>
    			</button>
    		  </FixedDiv>
        </SubMenu>
      )}
    </Container>
  )
}

export default Menu
